import React from "react";
import { FeatherAlertCircle } from "@subframe/core";
import { CreditsOrRefundReceivedCategoryDetails } from "../../services/api";

interface CustomerCreditsOrRefundReceivedViewContentProps {
  details: CreditsOrRefundReceivedCategoryDetails | null;
  isLoading: boolean;
}

const formatDate = (value?: string) => {
  if (!value) return "—";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "—" : date.toLocaleDateString();
};

const InfoCard: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <div className="flex flex-col rounded border border-neutral-border bg-white px-4 py-3">
    <span className="text-caption text-subtext-color">{label}</span>
    <span className="text-body-bold text-default-font">{value || "—"}</span>
  </div>
);

const CustomerCreditsOrRefundReceivedViewContent: React.FC<
  CustomerCreditsOrRefundReceivedViewContentProps
> = ({ details, isLoading }) => {
  const hasDetails = Boolean(details);

  if (!details) {
    return (
      <div className="flex w-full flex-col items-center gap-2 rounded-md border border-dashed border-neutral-border bg-neutral-50 px-6 py-10 text-center text-body text-subtext-color">
        <FeatherAlertCircle className="text-neutral-400" />
        <span>Credits or refund received details are not available.</span>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4 rounded-md border border-solid border-neutral-border bg-neutral-50 px-6 py-6">
      <div className="flex w-full items-center justify-between">
        <span className="text-heading-3 font-heading-3 text-default-font">
          Credits or Refunds Received Details
        </span>
      </div>

      {isLoading ? (
        <div className="flex w-full items-center justify-center py-12 text-body text-subtext-color">
          Loading transaction details...
        </div>
      ) : !hasDetails ? (
        <div className="flex w-full flex-col items-center gap-2 rounded border border-dashed border-neutral-border px-4 py-6 text-center text-body text-subtext-color">
          <FeatherAlertCircle className="text-neutral-400" />
          <span>No details available.</span>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-3">
          <InfoCard label="Date" value={formatDate(details?.date)} />
          <InfoCard
            label="Received Via"
            value={details?.payment_mode || "—"}
          />
          <InfoCard
            label="From Account"
            value={details?.from_account_name || details?.from_account_id || "—"}
          />
          {(details?.vendor_name || details?.vendor_id) && (
            <InfoCard
              label="Received From"
              value={details?.vendor_name || details?.vendor_id || "—"}
            />
          )}
          {details?.reference_number && (
            <InfoCard
              label="Reference Number"
              value={details.reference_number}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerCreditsOrRefundReceivedViewContent;
